import { createReducer } from "@reduxjs/toolkit";
import { setEmail, setPassword } from "../actions/myAccountPage";
import { logOut } from "../actions/user";
import { resolveRsaaErrorMessage } from "../utils/rsaaErrorMessage";

export type IMyAccountPageState = {
    changeEmailError?: string;
    changePasswordError?: string;
};

const getDefaultState = (): IMyAccountPageState => {
    return {
        changeEmailError: undefined,
        changePasswordError: undefined,
    };
};

export const myAccountPage = createReducer(getDefaultState(), (builder) => {
    builder.addCase(setEmail.success, (state, action) => {
        state.changeEmailError = action.payload.error;
    });
    builder.addCase(setEmail.error, (state, action) => {
        state.changeEmailError = resolveRsaaErrorMessage(
            action.payload,
            "Failed to change email"
        );
    });
    builder.addCase(setPassword.success, (state, action) => {
        state.changePasswordError = action.payload.error;
    });
    builder.addCase(setPassword.error, (state, action) => {
        state.changePasswordError = resolveRsaaErrorMessage(
            action.payload,
            "Failed to change password"
        );
    });
    builder.addCase(logOut.request, () => getDefaultState());
});
